export class Favorites {
    constructor() {
        this.setElementClasses();

        this.bindElementsCallback($('.' + this.ADD_CLASS), this.bindAdd);
        this.bindElementsCallback($('.' + this.REMOVE_CLASS), this.bindRemove);
        $(`.${this.ITEM_CLASS}`).off().bind("click", event => this.productClickHandler.call(this, event));
    }

    setElementClasses() {
        this.ADD_CLASS = 'js-favorites_add';
        this.REMOVE_CLASS = 'js-favorites_remove';

        this.ADD_TEXT = 'Добавить в избранное';
        this.REMOVE_TEXT = 'Удалить из избранного';

        this.ICON_CLASS = 'js-favorites_icon';
        this.TEXT_CLASS = 'js-favorites_text';

        this.TOOLTIP_COUNTER_CLASS = "js-favorites-count";
        this.TOOLTIP_CLASS = "hover-tooltip";

        this.ITEM_CLASS = "js-profile_favorite-item";
    }

    bindAdd(id, element) {
        let
            $this = this;

        if (this.blockedForPhones(element)) {
            return this.redirectToCard(element);
        }

        $.post('/ajax/favorites/add/' + id + '/' + $this.getPrice(element) + '/', {}, function (result) {
            if (!result || result.type !== 'success') {
                console.error('Избранный не добавлен');

                return;
            }

            $this.send_to_mindbox('add', id, $this.getPrice(element));

            (window.dataLayer || []).push({
                mindbox: {
                    operation: "AddProductToIzbrannoe2ItemList",
                    data: {
                        addProductToList: {
                            product: {
                                sku: {ids: {website: $(this).data('name')}},
                                ids: {website: id}
                            },
                        }
                    }
                }
            });

            $('.' + $this.ADD_CLASS + '[data-product="' + id + '"]').each(function (index, addElement) {
                $this.switchTo('remove', $(addElement));
            });

            $this.bindElementsCallback(element, $this.bindRemove);

            refreshHeaderBasket();
            if (element.hasClass('ab_favorite')) {
                $this.refreshFavoriteCounter(id, element);
            }

            BX.Event.EventEmitter.emit('Mario.Favorite:added', { id });
            element.trigger('mario.favorites.added');
            if (window._store) {
                window._store.dispatch(window._ActionCreators.addItemToFavorites(id));
            }
        }, 'json');
    }

    bindRemove(id, element) {
        let
            $this = this;

        if (this.blockedForPhones(element)) {
            return this.redirectToCard(element);
        }

        $.post('/ajax/favorites/remove/' + id + '/' + $this.getPrice(element) + '/', {}, function (result) {
            if (!result || result.type !== 'success') {
                console.error('Избранный не добавлен');

                return;
            }

            $this.send_to_mindbox('remove', id, $this.getPrice(element));

            $('.' + $this.REMOVE_CLASS + '[data-product="' + id + '"]').each(function (index, removeElement) {
                $this.switchTo('add', $(removeElement));
            });

            if ($('.js-profile-page').length > 0) {
                $(element).closest(`.${this.ITEM_CLASS}`).remove()
            }

            $this.bindElementsCallback(element, $this.bindAdd);

            refreshHeaderBasket();
            if (element.hasClass('ab_favorite')) {
                $this.refreshFavoriteCounter(id, element);
            }

            BX.Event.EventEmitter.emit('Mario.Favorite:removed', { id });
            element.trigger('mario.favorites.removed');
            if (window._store) {
                window._store.dispatch(window._ActionCreators.removeItemFromFavorites(id));
            }
        }, 'json');
    }

    bindElementsCallback(elements, callback) {
        let $this = this;

        elements.off('click').on('click', function (event) {
            event.preventDefault();

            callback.call($this, $(this).data('product'), $(this));
        });
    }

    switchTo(type, element) {
        let textBlock = element.find('.' + this.TEXT_CLASS),
            icon = (element.hasClass(this.ICON_CLASS)) ?
                element :
                element.find('.' + this.ICON_CLASS);

        switch (type) {
            case 'add':
                element.removeClass(this.REMOVE_CLASS).addClass(this.ADD_CLASS);

                if (textBlock && textBlock.length) {
                    textBlock.text(element.data('add-text') || this.ADD_TEXT);
                }

                if (icon && icon.length) {
                    icon.removeClass('active');
                }
                break;

            case 'remove':
                element.removeClass(this.ADD_CLASS).addClass(this.REMOVE_CLASS);

                if (textBlock && textBlock.length) {
                    textBlock.text(element.data('remove-text') || this.REMOVE_TEXT);
                }

                if (icon && icon.length) {
                    icon.addClass('active');
                }
                break;
        }
    }

    blockedForPhones(element) {
        return (element.hasClass('js-catalog-card_favorite') && $(window).width() <= TABLET_BREAKPOINT);
    }

    redirectToCard(element) {
        let linkWrapper = $(element).closest('a');

        if (!linkWrapper || linkWrapper.length <= 0) {
            return false;
        }

        window.location.href = linkWrapper.attr('href');

        return true;
    }

    getPrice(element) {
        let
            $parent;

        if (((window._store || {}).state || {}).card) {
            const firstOffer = Object.values(_store.state.card.offers)[0];
            return firstOffer.price;
        }

        if ($(element).closest('.js-offer-switcher').length > 0) {
            $parent = $(element).closest('.js-offer-switcher');
            return parseInt($parent.find('.js-new-price').parent().data('price'));
        } else if ($(element).closest('.js-section_product').length > 0) {
            $parent = $(element).closest('.js-section_product');
            return parseInt($parent.find('.js-new-price').data('value'));
        } else if ($(element).closest('.js-basket_item').length > 0) {
            $parent = $(element).closest('.js-basket_item');
            return parseInt($parent.data('price'));
        } else {
            $parent = $(element).closest(`.${this.ITEM_CLASS}`);
            return parseInt($parent.data('price'));
        }
    }

    send_to_mindbox(operation, id, price) {
        if (typeof mindbox != 'undefined') {
            if (operation == 'add'){
                mindbox('async', {
                    operation: 'AddProductToFavoritesItemList',
                    data: {
                        addProductToList: {
                            product: {
                                ids: {
                                    website: id
                                }
                            },
                            price: price
                        }
                    }
                });
            } else {
                mindbox('async', {
                    operation: 'RemoveProductFromFavoritesItemList',
                    data: {
                        removeProductFromList: {
                            product: {
                                ids: {
                                    website: id
                                }
                            },
                            price: price
                        }
                    }
                });
            }
        }
    }

    refreshFavoriteCounter(id, element) {
        $.post('/ajax/favorites/product_count/', {id}, null, 'json')
            .done(result => {
                if (result.type === 'error') {
                    console.error('Не удалось получить количество выборов для продукта');
                    return;
                }
                let iconCounter = element.find('span:first-child'),
                    tooltipCounter = element.find('.' + this.TOOLTIP_COUNTER_CLASS),
                    text = element.hasClass('active') ? "Удалить из избранного" : "Добавить в избранное",
                    additionalText = "", plural;

                plural = get_plural_word(parseInt(result.value), 'человек', 'человека', 'человек');
                additionalText = "<br> Уже в избранном у <span class=\"" +
                    this.TOOLTIP_COUNTER_CLASS + "\">" + result.value + "</span> " + plural;

                if (parseInt(result.value) > 0 && tooltipCounter.length === 0) {
                    element.find('.' + this.TOOLTIP_CLASS).html(text + additionalText);
                } else if (parseInt(result.value) === 0) {
                    element.find('.' + this.TOOLTIP_CLASS).html(text);
                    iconCounter.text("");
                    return;
                } else {
                    element.find('.' + this.TOOLTIP_CLASS).html(text + additionalText);
                }
                iconCounter.text(result.value);
            })
            .fail(() => {
                console.error('Не удалось получить количество выборов для продукта')
            });
    }

    productClickHandler(event) {
        if (!$(event.target).is("a.hover-sec__link")) return;

        let target = $(event.target).closest(".product__block"), arDataPush,
            dataLayer = window.dataLayer || [];

        arDataPush = [{
            name: target.find(".product__name").text(),
            id: target.data("product"),
            price: target.parent().data('price') || 0,
            brand: target.find('.product__brand').text() || "",
            category: target.data('section') !== "Обувь" ? target.data('section') : "",
            variant: target.data('color') || "",
            position: '' + (target.parent().index() + 1),
            dimension17: target.data('discount-code'),
            dimension3: target.data('endsoon') ? 'endsoon' : '',
        }];

        dataLayer.push({
            event: 'productClick',
            ecommerce: {
                click: {
                    actionField: {list: "favorites"},
                    products: arDataPush
                }
            }
        });
    }

    static handleAddToBasketClick(modal) {
        modal.modal('hide');

        let chosenOfferId = 0,
            modalInputs = $(".js-product_offer-id"),
            productId, product,
            dataLayer = window.dataLayer || [];

        //т.к. модалок много, надо пробегать по каждой в поисках заполненного значения
        modalInputs.each((index, input) => {
            if ($(input).val()) {
                chosenOfferId = parseInt($(input).val(), 10);
            }
        });

        productId = get_product_by_offer(chosenOfferId, true);
        product = $(`.product__block[data-product=${productId}]`);

        if (productId && product) {
            dataLayer.push({
                'event': 'addToCart',
                'ecommerce': {
                    'currencyCode': 'RUB',
                    'add': {
                        'products': [{
                            'name': product.find(".product__name").text() || '',
                            'id': product.data("product") || '',
                            'price': product.parent().data('price') || 0,
                            'brand': product.find('.product__brand').text() || '',
                            'category': product.data('section') !== "Обувь" ? product.data('section') : "" || '',
                            'variant': product.data('color') || '',
                            'quantity': 1
                        }],
                    },
                    'actionField': {list: 'favorites', action: 'add'}
                }
            });
        }
        //а потом чистить инпуты, чтобы заполненный был всегда только один
        modalInputs.each((index, input) => {$(input).val("")});
    }
}
